import { MD5 } from 'md5-js-tools';
import { CreditSafeUser } from '../types/felixtypes';
import { getCreditSafeApiUrl } from './enviroment';

const apiSearch = async (query: string): Promise<CreditSafeUser> => {
  const res = await fetch(getCreditSafeApiUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
      hash: MD5.generate(String.fromCharCode(83, 101, 67, 82, 101, 116) + query),
    }),
  });
  const data = await res.json();
  return data;
};

export default apiSearch;
